module.exports = __webpack_public_path__ + "static/media/wt4.5b4bce4d.png";